import PropTypes from "prop-types";
import React from "react";
import { SelectableMenuItem } from "./SelectableMenuItem";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors";
import { AppFeatures } from "../../constants/featureFlags";
import { useFeature } from "../../hooks/useFeature";

export const SportCategoryMenuItem = ({ item, ...restProps }) => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const isFavouriteSportsEnabled = useFeature(AppFeatures.FAVOURITE_SPORTS);

  return (
    <SelectableMenuItem
      item={item}
      hasFavouriteFeature={isFavouriteSportsEnabled && isAuthenticated}
      isSportCategory={true}
      {...restProps}
    />
  );
};

SportCategoryMenuItem.propTypes = {
  item: PropTypes.object,
  hasFavouriteFeature: PropTypes.bool
};
